/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AuthService } from './services/auth.service';
import { ManageService } from './services/manage.service';
import { CompaniesService } from './services/companies.service';
import { CompanyService } from './services/company.service';
import { UsersApiService } from './services/users-api.service';
import { StatisticsService } from './services/statistics.service';
import { EventsService } from './services/events.service';
import { TicketsService } from './services/tickets.service';
import { CashRegisterService } from './services/cash-register.service';
import { PayoffService } from './services/payoff.service';
import { CustomersService } from './services/customers.service';
import { PaymentService } from './services/payment.service';
import { ExportsService } from './services/exports.service';
import { FilesService } from './services/files.service';
import { HealthService } from './services/health.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AuthService,
    ManageService,
    CompaniesService,
    CompanyService,
    UsersApiService,
    StatisticsService,
    EventsService,
    TicketsService,
    CashRegisterService,
    PayoffService,
    CustomersService,
    PaymentService,
    ExportsService,
    FilesService,
    HealthService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
